import { Form, FormikForm } from "@skilitics/designer-ui-components";

import { BooleanComparisonView, booleanComparisonFormatStrings } from "../../../values/forms/comparison-views/index.ts";
import type { BooleanConditionContext } from "../booleanConditionBuilder";

export type BooleanConditionFormValues = BooleanConditionContext["config"];

type BooleanConditionFormProps = {
  disabled?: boolean;
  initialValues: BooleanConditionFormValues;
  onSubmit: (newValues: BooleanConditionFormValues) => void;
};

export const BooleanConditionForm = ({ disabled = false, initialValues, onSubmit }: BooleanConditionFormProps) => (
  <FormikForm<BooleanConditionFormValues>
    initialValues={initialValues}
    onSubmit={onSubmit}
    submitOnBlur
    explicitLabels
    formatStrings={booleanComparisonFormatStrings}
    dataTest="boolean-condition-form"
  >
    <Form $labelAlignment="inline">
      <BooleanComparisonView disabled={disabled} />
    </Form>
  </FormikForm>
);
